import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function TerminalBar() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-zinc-950/95 backdrop-blur-md border-b border-zinc-800/80 px-4 py-1.5 text-[10px] font-mono tracking-wider text-zinc-500 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-zinc-600">user@bsmc:~$</span>
        <span className="flex items-center gap-1.5 text-cyan-400">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
          system operational
        </span>
      </div>
      <div className="hidden md:flex items-center gap-4">
        <span>shadow_sync: <span className="text-cyan-400">ACTIVE</span></span>
        <span>doppelganger: <span className="text-amber-400">STANDBY</span></span>
        <span>telemetry: <span className="text-rose-500 font-bold">ZERO</span></span>
        <span className="text-zinc-600">{time.toLocaleTimeString('en-US', { hour12: false })}</span>
      </div>
      <SafeIcon icon={FiIcons.FiTerminal} className="text-zinc-600" />
    </div>
  );
}